var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientmyprescriptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.47,
    height: 60.16,
    viewBox: "0 0 47.47 60.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18360"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12910",
    d: "M-1345.422-16110.844h3.909v-4.867h4.536v4.867h4.724v4.065h-4.724v4.2h-4.536v-3.146h-3.909z",
    transform: "translate(1363 16132.334)",
    style: {
      fill: "#ea5d6e",
      stroke: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12911",
    d: "m-1348.318-16120.472.644-4.707.133-.974 3.179-.912 2.451-2.949 2.171-1.2h2.924l1.11 2.387 1.237 1.758 3.257.912 1.035 2v2.756l-.6.9-.438.661-1.349-.06-.592-.026-1.318-.059-3.312-.147-7.723-.343",
    transform: "translate(1363 16132.334)",
    style: {
      fill: "#ea5d6e",
      stroke: "#707070"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17867"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11750",
    d: "M43.945 6.345H33.721a3.706 3.706 0 0 0-3.347-2.122h-1.74a4.935 4.935 0 0 0-9.767 0H17.1a3.707 3.707 0 0 0-3.347 2.122H3.525A3.529 3.529 0 0 0 0 9.87v46.765a3.529 3.529 0 0 0 3.525 3.525h40.42a3.529 3.529 0 0 0 3.525-3.525V9.87a3.529 3.529 0 0 0-3.525-3.525zm-28.2 1.579A1.353 1.353 0 0 1 17.1 6.573h2.89A1.175 1.175 0 0 0 21.165 5.4v-.465a2.585 2.585 0 0 1 5.17 0V5.4a1.175 1.175 0 0 0 1.175 1.173h2.864a1.353 1.353 0 0 1 1.351 1.351v3.121h-15.98zM45.12 56.635a1.176 1.176 0 0 1-1.175 1.175H3.525a1.176 1.176 0 0 1-1.175-1.175V9.87A1.176 1.176 0 0 1 3.525 8.7H13.4v2.35H5.875A1.175 1.175 0 0 0 4.7 12.22v15.745a1.175 1.175 0 1 0 2.35 0V13.4h33.37v39.71H7.05V38.54a1.175 1.175 0 0 0-2.35 0v15.745a1.175 1.175 0 0 0 1.175 1.175H41.6a1.175 1.175 0 0 0 1.175-1.175V12.22a1.175 1.175 0 0 0-1.175-1.175h-7.52V8.7h9.87a1.176 1.176 0 0 1 1.17 1.17zm0 0",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11751",
    d: "M137.175 145.28h3.055v3.055a1.175 1.175 0 0 0 1.175 1.175h4.7a1.175 1.175 0 0 0 1.175-1.175v-3.055h3.055a1.175 1.175 0 0 0 1.175-1.175v-4.7a1.175 1.175 0 0 0-1.175-1.175h-3.055v-3.055a1.175 1.175 0 0 0-1.175-1.175h-4.7a1.175 1.175 0 0 0-1.175 1.175v3.055h-3.055a1.175 1.175 0 0 0-1.175 1.175v4.7a1.175 1.175 0 0 0 1.175 1.175zm1.175-4.7h3.05a1.175 1.175 0 0 0 1.175-1.175v-3.055h2.35v3.055a1.175 1.175 0 0 0 1.175 1.175h3.055v2.35H146.1a1.175 1.175 0 0 0-1.175 1.175v3.055h-2.35v-3.055a1.175 1.175 0 0 0-1.175-1.175h-3.05zm0 0",
    transform: "translate(-120.021 -118.255)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11752",
    d: "M209.444 404h-11.437a1.175 1.175 0 1 0 0 2.35h11.437a1.175 1.175 0 1 0 0-2.35zm0 0",
    transform: "translate(-173.704 -356.53)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11753",
    d: "M92.334 370.706a1.175 1.175 0 0 0 1.662 0l4.7-4.7a1.175 1.175 0 0 0-1.662-1.662l-3.869 3.869-1.327-1.327a1.175 1.175 0 0 0-1.662 1.661zm0 0",
    transform: "translate(-79.276 -321.23)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11754",
    d: "M196.832 325.175a1.175 1.175 0 0 0 1.175 1.175h11.437a1.175 1.175 0 1 0 0-2.35h-11.437a1.175 1.175 0 0 0-1.175 1.175zm0 0",
    transform: "translate(-173.704 -285.93)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11755",
    d: "M92.334 290.706a1.175 1.175 0 0 0 1.662 0l4.7-4.7a1.175 1.175 0 0 0-1.662-1.662l-3.869 3.869-1.327-1.327a1.175 1.175 0 1 0-1.662 1.662zm0 0",
    transform: "translate(-79.276 -250.63)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11756",
    d: "M41.175 275.35a1.175 1.175 0 1 0-.831-.344 1.184 1.184 0 0 0 .831.344zm0 0",
    transform: "translate(-35.299 -240.923)",
    style: {
      fill: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11757",
    d: "M193.175 34.35a1.175 1.175 0 1 1 .831-.344 1.184 1.184 0 0 1-.831.344zm0 0",
    transform: "translate(-185.964 -28.24)",
    style: {
      fill: "#6f7071"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientmyprescriptions);
export default __webpack_public_path__ + "static/media/patientmyprescriptions.018a16150d56eeda4afc4bc17959653c.svg";
export { ForwardRef as ReactComponent };